import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translation files
import koCommon from '@/shared/assets/locales/ko/common.json';
import enCommon from '@/shared/assets/locales/en/common.json';
import zhCommon from '@/shared/assets/locales/zh/common.json';
import jaCommon from '@/shared/assets/locales/ja/common.json';

const resources = {
  ko: {
    common: koCommon,
  },
  en: {
    common: enCommon,
  },
  zh: {
    common: zhCommon,
  },
  ja: {
    common: jaCommon,
  },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    supportedLngs: ['ko', 'en', 'zh', 'ja'],
    lng: 'ko', // 기본 언어를 한국어로 강제 설정
    fallbackLng: 'ko', // 기본 언어를 한국어로 설정
    // debug: process.env.NODE_ENV === 'development',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    defaultNS: 'common',
    ns: ['common'],
    // React Suspense 지원
    react: {
      useSuspense: false,
    },
  });

// 언어 변경 함수를 export
export const changeLanguage = async (lng: 'ko' | 'en' | 'zh' | 'ja') => {
  console.log('🌐 [i18n] changeLanguage 호출:', lng, '(이전:', i18n.language, ')');
  await i18n.changeLanguage(lng);
  console.log('🌐 [i18n] changeLanguage 완료:', i18n.language);
  return true
};

export default i18n;
